import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

interface ImagePreviewerProps {
  image?: string | File; // Puede ser una URL (string) o un archivo (File)
  maxWidth?: string; // Máximo ancho (ej: "100%", "300px")
  maxHeight?: string; // Máximo alto (ej: "300px", "auto")
}

const ImagePreviewer: React.FC<ImagePreviewerProps> = ({
  image,
  maxWidth = '100%', // Por defecto ajusta al 100% del contenedor
  maxHeight = 'auto',
}) => {
  const [preview, setPreview] = useState<string | null>(null);

  // Actualiza la previsualización cuando cambia la imagen
  useEffect(() => {
    if (image) {
      if (typeof image === 'string') {
        // Si es una URL, úsala directamente
        setPreview(image);
      } else if (image instanceof File) {
        // Si es un archivo local, crea una URL temporal
        const fileReader = new FileReader();
        fileReader.onloadend = () => {
          setPreview(fileReader.result as string);
        };
        fileReader.readAsDataURL(image);
      }
    } else {
      setPreview(null); // Reinicia si no hay imagen
    }
  }, [image]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        overflow: 'hidden',
        borderRadius: '10px', // Opcional: bordes redondeados
      }}
    >
      {preview ? (
        <img
          src={preview}
          alt="Previsualización"
          style={{
            width: '100%', // Se ajusta al contenedor
            height: 'auto',
            objectFit: 'contain', // Mantiene las proporciones
          }}
        />
      ) : (
        <p style={{ color: 'gray' }}>No hay imagen seleccionada</p>
      )}
    </Box>
  );
};

export default ImagePreviewer;